import React, { useState, useEffect, useRef, createRef } from 'react'
import * as constants from '../../globals/constants'
import { useAxios } from '../../utils/useAxios'
import styled from 'styled-components'
import { getComma } from '../../utils/getComma'
import { useNavigate } from 'react-router-dom'

// components
import { Selector } from '../../components'
import ToggleBtn from '../atom/toggleBtn/ToggleBtn'
import Button from '../../components/atom/button/Button'
import ChkBox from '../atom/checkBox/ChkBox'
import Empty from '../../pages/reviewList/components/Empty'
import DropDown from '../dropdown/DropDown'
import Loading from '../../components/atom/loading/Loading'

// images
import DefaultImg from '../../assets/image/menu/ic-menu-default.svg'

const MoItemMenu = ({
  dataItems,
  dataItem,
  checkedItems,
  setCheckedItems,
  saleItems,
  setSaleItems,
  nonsaleItems,
  setNonSaleItems,
  postSaleItem,
  isInit,
  getLoading,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const { fetchData, loading, postdata, error } = useAxios()
  const [isUpdate, setIsUpdate] = useState(false) // (상태값 변경 업데이트)

  // 탭(메뉴, 옵션)
  const [selectTabIdx, setSelectTabIdx] = useState(0)
  const navigate = useNavigate()

  // 데이터 배열 담는 곳
  const [categoryList, setCategoryList] = useState() //  categoryList 담는 곳
  const [itemList, setItemList] = useState() // itemList 담는 곳
  const [combinedItemList, setCombinedItemList] = useState() // itemList 담는 곳

  // 숨김 처리시(hide)
  // const hideRef = useRef(null)
  const hideRefs = Array.from({ length: dataItem.length }).map(() =>
    createRef(),
  )

  const handleTab = (flag) => {
    // setOrderIncludeCancel(true)
    setSelectTabIdx(flag)

    if (flag === 0) {
      navigate('/itemList')
    }
    if (flag === 1) {
      navigate('/optionList')
    }
  }

  // 정렬 dropdown
  const sortOption = ['등록순', '오름차순', '내림차순']
  const [sortOptionStatus, setSortOptionStatus] = useState(sortOption[0])

  // 판매중 토글 클릭
  const handleSaleClick = () => {
    // console.log('checkedItems', checkedItems)
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedItemList에서 saleYn이 'Y'가 아닌 항목만 필터링
          const combinedItem = combinedItemList.find(
            (combined) => combined.itemCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'Y'
        }),
      ]),
    ]

    setSaleItems(updatedSaleItems)
    postSaleItem(updatedSaleItems, [])
  }

  // 숨김 토글 클릭
  const handleNonSaleClick = () => {
    if (checkedItems.length === 0) {
      alert('메뉴를 선택해주세요.')
      return
    }

    const updatedNonSaleItems = [
      ...new Set([
        ...saleItems,
        ...checkedItems.filter((item) => {
          // combinedItemList에서 saleYn이 'N'가 아닌 항목만 필터링
          const combinedItem = combinedItemList.find(
            (combined) => combined.itemCode === item,
          )
          return combinedItem && combinedItem.saleYn !== 'N'
        }),
      ]),
    ]

    setNonSaleItems(updatedNonSaleItems)
    postSaleItem([], updatedNonSaleItems)
    // setIsUpdate(true)
  }

  // 전체 체크박스 핸들러
  const handleAllChecked = (checked) => {
    if (checked) {
      // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
      const idArray = []
      itemList.forEach((item) => idArray.push(item.itemCode))
      setCheckedItems(idArray)
    } else {
      // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
      setCheckedItems([])
    }
  }

  // 개별 체크박스 핸들러
  const handleCheckedItem = (checked, chk) => {
    if (checked) {
      setCheckedItems((prev) => [...prev, chk])
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== chk))
    }
  }

  // 테이블 toggle 개별 스위치 핸들러
  const handleSellChange = (item, newValue, index) => {
    item.saleYn = newValue
    const itemRef = hideRefs[index].current

    // 숨김
    if (item.saleYn === 'N') {
      setNonSaleItems((prevNonSaleItems) => {
        const newNonSaleItems = [item.itemCode]

        itemRef.classList.add('hide')

        return newNonSaleItems
      })
    }
    // 판매중
    if (item.saleYn === 'Y') {
      setSaleItems((prevSaleItems) => {
        const newSaleItems = [item.itemCode]

        itemRef.classList.remove('hide')

        return newSaleItems
      })
    }
  }

  useEffect(() => {
    setCategoryList(dataItems)
    // 정렬된 아이템 리스트를 담을 변수

    let sortedItemList = dataItem.slice() // 기존 배열 복사
    // console.log('필터링 전', sortedItemList)

    if (sortOptionStatus === '오름차순') {
      sortedItemList.sort((a, b) => {
        return a.itemName.localeCompare(b.itemName)
      })
    } else if (sortOptionStatus === '내림차순') {
      sortedItemList.sort((a, b) => {
        return b.itemName.localeCompare(a.itemName)
      })
    }

    // 정렬된 리스트를 상태로 설정
    if (sortOptionStatus === '등록순') {
      setItemList(dataItem)
    } else {
      setItemList(sortedItemList)
    }

    // console.log('카테고리 필터링 결과:', sortedItemList)
  }, [dataItems, dataItem, sortOptionStatus])

  useEffect(() => {
    if (itemList) {
      const menuItems = itemList.filter((item) => item.saleYn === 'Y')
      const hiddenItems = itemList.filter((item) => item.saleYn === 'N')
      const combinedItems = [...menuItems, ...hiddenItems]

      setCombinedItemList(combinedItems)
    }
  }, [itemList])

  return (
    <>
      {getLoading ? (
        <Loading />
      ) : (
        <>
          <div>
            <Selector
              isLeftAlign={true}
              leftText={'메뉴관리'}
              rightText={'옵션관리'}
              selectedIdx={selectTabIdx}
              handleTab={handleTab}
            />
          </div>
          {dataItem.length === 0 ? (
            <Empty pointTxt={'조회된 상품'} txt={'이 없습니다.'} />
          ) : (
            <>
              <MoItemTop>
                <ChkBox
                  type="checkbox"
                  id={'allChk'}
                  checked={
                    checkedItems.length === itemList?.length ? true : false
                  }
                  onChange={(e) => handleAllChecked(e.target.checked)}
                />
                <MoTableHeaderBox>
                  <DropDown
                    defaultOption={'등록순'}
                    options={sortOption}
                    setOption={setSortOptionStatus}
                    value={sortOptionStatus}
                  />
                  <Button
                    type="button"
                    width={79 + 'px'}
                    height={28 + 'px'}
                    radius={4 + 'px'}
                    onClick={handleSaleClick}
                  >
                    판매중
                  </Button>
                  <Button
                    type="button"
                    width={79 + 'px'}
                    height={28 + 'px'}
                    radius={4 + 'px'}
                    onClick={handleNonSaleClick}
                  >
                    숨김
                  </Button>
                </MoTableHeaderBox>
              </MoItemTop>
              <ul>
                {combinedItemList?.map((item, i) => {
                  const itemClassName =
                    item.saleYn === 'N' ? 'MenuItem hide' : 'MenuItem'
                  return (
                    <MoItemLi
                      key={i}
                      ref={hideRefs[i]}
                      className={itemClassName}
                    >
                      <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <ChkBox
                            id={item.itemCode}
                            // checked={checkedItems[i]}
                            checked={
                              checkedItems.includes(item.itemCode)
                                ? true
                                : false
                            }
                            value={item.itemCode}
                            onChange={(e) =>
                              handleCheckedItem(e.target.checked, item.itemCode)
                            }
                          />
                          <p className="categoryName">
                            {item.categoryList[0].categoryName}
                          </p>
                        </div>
                        <ToggleBtn
                          yn={item.saleYn}
                          setYn={(newValue) => {
                            // console.log('handleSellChange item', item)
                            // console.log('handleSellChange newValue', newValue)
                            handleSellChange(item, newValue, i)
                          }}
                          id={i + item.itemCode}
                          width={79}
                        />
                      </div>
                      <div className="d-flex align-items-center gap-4 mt-4">
                        <MoItemImg>
                          <img
                            src={
                              !item.cImg
                                ? DefaultImg
                                : `${constants.IMG_URL + item.cImg}`
                            }
                            alt="상품사진"
                            className=""
                          />
                        </MoItemImg>
                        <div>
                          <p className="mb-2">{item.itemName}</p>
                          <p className="fw-bold">
                            {getComma(item.salePrice)}원
                          </p>
                        </div>
                      </div>
                    </MoItemLi>
                  )
                })}
              </ul>
            </>
          )}
        </>
      )}
    </>
  )
}

export default MoItemMenu

const MoItemTop = styled.div`
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f3f3;
  margin-top: 30px;
`

const MoItemLi = styled.li`
  padding: 20px 0;
  border-bottom: 1px solid #f3f3f3;
  color: #000;
  .categoryName {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  /* 숨김 처리로 변할시 */
  &.hide {
    opacity: 0.5;
  }
`

const MoItemImg = styled.div`
  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  img {
    width: 100%;
    border-radius: 50%;
    object-fit: contain;
  }
`

const MoTableHeaderBox = styled.div`
  /*mb-4 d-flex gap-2 justify-content-end  */
  /* margin-bottom: 16px; */
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  gap: 7px;
  /* .sortDropdown {
    width: 113px;
  } */
`
